import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {NgForm} from '@angular/forms';
import {EditComponent} from '../../../core/components/edit-component';
import {ApiResponse, DecimalPlacesPipe} from 'common-shared';
import {PropertyModel} from '../../../properties/models/property.model';
import {UnitService} from '../../units/unit.service';
import {GLOBAL} from 'common-shared';
import {ClassificatorQuery} from 'common-shared';
import {ClassificatorValuesQuery} from 'common-shared';
import {ClassificatorsQuery} from 'common-shared';

@Component({
  selector: 'mes-web-property-edit',
  templateUrl: './property-edit.component.html'
})
export class PropertyEditComponent extends EditComponent implements OnInit {
  @Input() response: ApiResponse<any>;
  @Input() property: PropertyModel;
  @Output() changed = new EventEmitter<boolean>();
  @ViewChild(NgForm, {static: true}) form: NgForm;

  constructor(public classificatorValueService: ClassificatorValuesQuery, public classificatorsQuery: ClassificatorsQuery, public unitService: UnitService, private decimalPlacesPipe: DecimalPlacesPipe) {
    super();
  }

  ngOnInit() {
    this.form.statusChanges.subscribe(value => {
      this.changed.emit(this.form.pristine);
    });
  }

  getPow(roundingFactor: number) {
    if (roundingFactor < 0) {
      return Math.pow(10, -1 * roundingFactor);
    }
    return this.decimalPlacesPipe.transform(Math.pow(10, -1 * roundingFactor), roundingFactor);
  }

  isChoice(property: PropertyModel) {
    return property.TypeClv === GLOBAL.Classificators.PropertyType.Choice;
  }

  isNumeric(property: PropertyModel) {
    return property.TypeClv === GLOBAL.Classificators.PropertyType.Numeric;
  }

  typeChanged(typeClv: ClassificatorQuery) {
    const id = (typeClv || {Id: null}).Id;
    if (id !== GLOBAL.Classificators.PropertyType.Numeric) {
      this.property.UnitId = null;
    }
    if (id !== GLOBAL.Classificators.PropertyType.Choice) {
      this.property.ChoiceTypeClassificatorId = null;
    }
  }
}
